// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1DWu2","title":"InfoRow_title__2qIrZ"};